<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Rol Grubu</label>
            <v-select-list :disabled="roles.length == 0" v-model="role" placeholder="Rol Grubu" label="Name" :options="roles"/>
        </div>
    </div>
</template>

<script>
import SystemDefinitionsApi from '@/api/system-definitions'
export default {
    props:{
        value:Object,
    },
    data() {
        return {
            roles:[]
        }
    },
    mounted(){
        this.getRoles()
    },
    methods:{
        getRoles(){
            SystemDefinitionsApi.Role.List().then(res=>{
                this.roles = res.data.Data
            })
        }
    },
    computed:{
        role:{
            get:function(){
                return this.roles.find(b=>b.Id==this.value.RoleGroupId)
            },
            set:function(value){
                this.value.RoleGroupId = value?.Id || null
            }
        },
    }
}
</script>

<style>

</style>